import type { BoardSample, ChapterBoard } from "../../board";
import { applyBoardCharacterMarkers } from "../../board/ApplyMarkers/character";
import { applyPovIndicator } from "../../marker/PovIndicator/apply";
import { applyBoardLocationMarkers } from "../../board/ApplyMarkers/location";
import type { BookTimelineLayout } from "@/lib/timeline/book/BookLayout";
import type { TimelineViewTransform } from "../../view/ViewTransform/transform";

/** Character markers + location boxes sampled from a chapter board. */
export function applyBoardTimelineOverlays(
  characterRoot: HTMLElement,
  locationRoot: HTMLElement,
  board: ChapterBoard,
  layout: BookTimelineLayout,
  sample: BoardSample,
  viewportWidth: number,
  viewportHeight: number,
  view: TimelineViewTransform,
  boardModelDebug: boolean,
): void {
  applyBoardCharacterMarkers(
    characterRoot,
    board,
    sample,
    layout,
    viewportWidth,
    boardModelDebug,
  );
  applyPovIndicator(
    characterRoot,
    layout,
    sample.playheadMs,
    viewportWidth,
    board,
    sample,
  );
  applyBoardLocationMarkers(
    locationRoot,
    layout,
    sample.playheadMs,
    viewportWidth,
    viewportHeight,
    view,
    boardModelDebug,
  );
}
